// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container-fluid b{
    font-size: 250%;
}

@media (max-width: 600px) {
    .container-fluid b {
        font-size: 7vw;
    }
}`, "",{"version":3,"sources":["webpack://./src/Components/screens/navbar.css"],"names":[],"mappings":"AAAA;IACI,eAAe;AACnB;;AAEA;IACI;QACI,cAAc;IAClB;AACJ","sourcesContent":[".container-fluid b{\n    font-size: 250%;\n}\n\n@media (max-width: 600px) {\n    .container-fluid b {\n        font-size: 7vw;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
